import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export type UndoFunction = () => Promise<void>;

export interface SetUndoOptions {
  title: string;
  description: string;
  functions: UndoFunction[];
}

export const useUndoStore = defineStore('undoStore', () => {
  let functions: UndoFunction[] = [];
  const title = ref('');
  const description = ref('');
  const subjectId = ref<string | number | null>(null);
  const hasUndo = ref(false);
  const executing = ref(false);

  function set(options: SetUndoOptions) {
    functions = [...options.functions];
    title.value = options.title;
    description.value = options.description;
    hasUndo.value = functions.length > 0;
  }

  function resetUndo() {
    functions = [];
    title.value = '';
    description.value = '';
    hasUndo.value = false;
  }

  async function executeUndo() {
    if (executing.value) return;
    executing.value = true;
    try {
      // Reverse order: undo the last change first.
      for (const func of [...functions].reverse()) {
        await func();
      }
      resetUndo();
    } finally {
      executing.value = false;
    }
  }

  return { title, description, subjectId, hasUndo, executing, set, resetUndo, executeUndo };
});
